<div class="tw-dialog-content">
  <app-custom-modal-header (close)="submit()"></app-custom-modal-header>
  <div class="tw-flex tw-flex-col">
    <div [innerHtml]="message">
    </div>
    <div class="tw-flex tw-justify-start tw-gap-2 -tw-mx-6 tw-px-6 tw-border-t tw-border-solid tw-border-gray-200 tw-pt-2 tw-mt-2"
         *ngIf="hasButton">
      <button pButton pRipple
              class="tw-btn-primary"
              (click)="submit()">{{ buttonText }}</button>
    </div>
  </div>
</div>
